<template lang="html">
  <nav
    class="content-breadcrumbs"
    aria-label="Навигация"
  >
    <div class="sm:hidden">
      <NuxtLink
        v-if="backItem?.to"
        :to="backItem.to"
        class="inline-flex max-w-full items-center gap-1.5 rounded-md border border-default bg-default px-2.5 py-2 text-sm font-medium text-default transition-colors hover:text-highlighted"
      >
        <UIcon
          name="i-lucide-arrow-left"
          class="size-4 shrink-0"
        />
        <span class="truncate">{{ backItem.label }}</span>
      </NuxtLink>
    </div>

    <div class="hidden sm:block">
      <UBreadcrumb
        :items="items"
        :ui="{
          root: 'text-sm text-muted',
          list: 'flex-nowrap',
          linkLabel: 'truncate max-w-40 sm:max-w-56',
        }"
      />
    </div>
  </nav>
</template>

<script setup lang="ts">
import type { BreadcrumbItem } from '@nuxt/ui'

const props = defineProps<{
  items: BreadcrumbItem[]
}>()

const backItem = computed(() => {
  const withLink = [...props.items].reverse().find(item => item.to)
  return withLink ?? null
})
</script>
